export default __webpack_public_path__ + "static/media/lobby_with_classrooms_preview.b840d5fd.png";